import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export const UNIT_CIRCLE_COS_WAVE_TRACE_PRESET: UnitCircleWidgetConfig = {
  id: 'unit-circle-cos-wave-trace',
  type: 'unit-circle',
  params: {
    point: { angle: 0, axisProjections: true },
    trigLines: { lines: ['cos'], referenceTriangle: true },
    traceWave: 'cos',
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 9, yStart: -2, yEnd: 2 },
      grid: { type: 'lines', visible: true },
    },
  },
};
